import {ChangeDetectionStrategy, Component, computed, inject, input, resource} from '@angular/core';
import {marked} from "marked";
import {ArticleService} from "../../../services/article.service";
import {NgComponentOutlet} from "@angular/common";
import {
  LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";

@Component({
  selector: 'homey-article-page',
  imports: [
    LotteriesAndFooterComponent,
    NgComponentOutlet
  ],
  templateUrl: './article-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlePageComponent {
  private readonly articleService = inject(ArticleService);
  public readonly slug = input.required<string>();
  private readonly article = computed(() => this.articleService.getArticle(this.slug())!);
  public readonly customComponent = computed(() => this.articleService.getCustomComponent(this.slug()));
  public readonly markdown = resource<string, {article?: string | null}>({
    params: () => ({
      article: this.customComponent() ? null : this.article()?.article ?? null
    }),
    loader: async ({params}) => {
      if (!params.article) {
        return '';
      }

      const md = await fetch(params.article);
      return marked.parse(await md.text());
    },
    defaultValue: ''
  });
}
